export default "__VITE_ASSET__CfkypZqT__"